/**
 * Fair Home V2 — live persona from auth + personalization status (H10)
 */
import { computed } from 'vue'
import { useTokenStore } from '@/features/auth/store'
import { usePersonalizationStatusQuery } from '@/queries/search'
import { resolveFairHomeV2PersonaState } from './fair-home-v2-persona.data'

export function useFairHomeV2Persona() {
  const tokenStore = useTokenStore()
  const statusQuery = usePersonalizationStatusQuery()

  const isAuthenticated = computed(() => tokenStore.isAuthenticated())

  const persona = computed(() =>
    resolveFairHomeV2PersonaState({
      isAuthenticated: isAuthenticated.value,
      status: statusQuery.data.value,
    }),
  )

  return {
    persona,
    isAuthenticated,
    statusQuery,
  }
}
